const SECURED_STITCH_BASE_URL = "https://securedstitch-bfcuddejg4d8beaj.canadacentral-01.azurewebsites.net";
const MEMBER_KEY = "30F5C69F-45F2-4650-99CB-0EF53DDD13F6";
const CAREPLUS_PRODUCT_ID = 46947734618331;

let carePlusQuoteId = null;
let carePlusPrice = 999; // Default Care+ price, can be overridden by API response

// === Function to Load Secured Stitch Widget ===
function loadSecuredStitchWidget() {
  const widget = document.getElementById('secured-stitch-widget');
  const controls = document.getElementById('secured-stitch-controls');

  if (widget) widget.innerHTML = '';
  if (controls) controls.innerHTML = `
    <div style="width: 100%; display: flex; justify-content: center; padding: 12px;">
      <button style="width: 100%; max-width: 320px; padding: 12px 20px; background: grey; color: #fff; border: none; border-radius: 6px; font-size: 16px; cursor: not-allowed;" disabled>
        Loading Care+...
      </button>
    </div>
  `;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.items.length === 0) throw new Error("Cart is empty!");

      const item = cart.items[0];
      const hasCarePlus = cart.items.some(ci => ci.id === CAREPLUS_PRODUCT_ID);

      const payload = {
        Member: MEMBER_KEY,
        CurrencyCode: "INR",
        Brand: item.vendor || "Generic",
        Price: item.price / 100,
        Name: item.title || "Product",
        Size: item.variant_title || "6",
        Product: "SNK",
        Gender: "m",
        SizeType: "UK"
      };

      console.log("🟢 Payload to Secured Stitch /quote:", payload);

      return fetch(`${SECURED_STITCH_BASE_URL}/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(data => {
          console.log("✅ Secured Stitch /quote Response:", data);
          carePlusQuoteId = data.quoteId;  // Using the quoteId as the unique ID for sale

          if (widget) {
            widget.innerHTML = `<div style="max-width: 100%; overflow-x: auto;">${data.html || "<p>Care+ Available</p>"}</div>`;
          }

          // Override internal price text
          const priceRegex = /\d+(?:\.\d+)?\s*INR/i;
          const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            if (priceRegex.test(node.textContent)) {
              node.textContent = node.textContent.replace(priceRegex, `₹${carePlusPrice}`);
            }
          }

          // Responsive Add Button
          if (controls) {
            if (hasCarePlus) {
              controls.innerHTML = `
                <div style="width: 100%; display: flex; justify-content: center; padding: 12px;">
                  <button id="add-careplus-btn" style="width: 100%; max-width: 320px; padding: 12px 20px; background: grey; color: #fff; border: none; border-radius: 6px; font-size: 16px; cursor: not-allowed;" disabled>
                    Care+ Already Added
                  </button>
                </div>
              `;
            } else {
              controls.innerHTML = `
                <div style="width: 100%; display: flex; justify-content: center; padding: 12px;">
                  <button id="add-careplus-btn" style="width: 100%; max-width: 320px; padding: 12px 20px; background: #007ace; color: #fff; border: none; border-radius: 6px; font-size: 16px; cursor: pointer;">
                    Add Care+ for ₹${carePlusPrice}
                  </button>
                </div>
              `;
            }
          }
        });
    })
    .catch(err => {
      console.error("❌ Secured Stitch Error:", err);
      if (controls) {
        controls.innerHTML = `<p style="color:red; padding: 12px; text-align: center;">Unable to load Care+ right now. Please refresh or try again later.</p>`;
      }
    });
}

// === Function to Add Care+ to Cart ===
function addCarePlusToCart() {
  if (!carePlusQuoteId || !carePlusPrice) {
    alert("Care+ plan not ready. Please wait.");
    return;
  }

  const careplusBtn = document.getElementById('add-careplus-btn');
  if (careplusBtn) {
    careplusBtn.innerText = "Adding...";
    careplusBtn.disabled = true;
  }

  // Use carePlusQuoteId as UniqueId to ensure both values are the same
  const uniqueId = carePlusQuoteId;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      quantity: 1,
      id: CAREPLUS_PRODUCT_ID,  // Variant ID for Care+ product
      properties: {
        quoteId: carePlusQuoteId,  // Use the same quoteId for both
        CarePlusPrice: carePlusPrice  // Price for Care+
      }
    })
  })
    .then(res => res.json())
    .then(data => {
      console.log("✅ Care+ added:", data);
      return fetch('/cart.js');
    })
    .then(res => res.json())
    .then(cart => {
      const event = new CustomEvent('cart:updated', { detail: { cart } });
      document.dispatchEvent(event);

      if (careplusBtn) {
        careplusBtn.innerText = "Added!";
        careplusBtn.disabled = true;
      }

      // Now trigger Secured Stitch /sale to complete the sale
      const salePayload = {
        quoteId: carePlusQuoteId,  // Same quoteId for the sale
        uniqueId: uniqueId,        // Use carePlusQuoteId as UniqueId
        sold: true,                // Mark as sold
        customerName: "Rishabh Maurya",  // Replace with dynamic customer name
        address: "Customer Address",     // Replace with customer address
        member: MEMBER_KEY         // Your Secured Stitch Member Key
      };

      // Send sale request to Secured Stitch API
      fetch(`${SECURED_STITCH_BASE_URL}/sale`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(salePayload)
      })
      .then(res => res.json())
      .then(saleData => {
        console.log("✅ Sale completed:", saleData);
        const saleId = saleData.saleId; // Ensure the response has saleId
        console.log("✅ Sale ID:", saleId);
      })
      .catch(err => {
        console.error("❌ Error completing the sale:", err);
      });

      // Reopen cart drawer
      if (typeof openCartDrawer === 'function') {
        openCartDrawer();
      } else if (document.querySelector('#CartDrawer')) {
        fetch('/cart')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('#CartDrawer');
            if (newDrawer) {
              document.querySelector('#CartDrawer').replaceWith(newDrawer);
              document.querySelector('#CartDrawer').classList.add('is-open');
            }
          });
      } else {
        location.reload();
      }
    })
    .catch(err => {
      console.error("❌ Add Care+ Error:", err);
      alert("Could not add Care+. Try again.");
      if (careplusBtn) {
        careplusBtn.innerText = "Add Care+";
        careplusBtn.disabled = false;
      }
    });
}

// === Hooks ===
document.addEventListener('DOMContentLoaded', loadSecuredStitchWidget);
document.addEventListener('cart:updated', loadSecuredStitchWidget);

document.addEventListener('click', (e) => {
  if (e.target && e.target.id === 'add-careplus-btn') {
    addCarePlusToCart();
  }
});

// Re-trigger widget after product add
document.addEventListener('click', function (e) {
  const isATC = e.target.matches('[type="submit"][name="add"]') || e.target.closest('form[action="/cart/add"]');
  if (isATC) {
    setTimeout(() => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (cart.items.length > 0) {
            loadSecuredStitchWidget();
          }
        });
    }, 1000);
  }
});

// Hide/show Care+ widget based on radio button
document.addEventListener('change', function (e) {
  if (e.target.matches('input[type="radio"]')) {
    const widget = document.getElementById('secured-stitch-widget');
    const controls = document.getElementById('secured-stitch-controls');

    const label = e.target.labels?.[0]?.textContent?.trim().toLowerCase() || '';

    if (label.includes('no, i would not like any additional services')) {
      if (widget) widget.style.display = 'none';
      if (controls) controls.style.display = 'none';
    } else {
      if (widget) widget.style.display = '';
      if (controls) controls.style.display = '';
    }
  }
});
